import * as qs from "qs";
import { emptyApi } from "./emptyApi";
import { Pagination } from "types/Models/pagination";
import { makeFormData } from "utils/makeFormData";
import {
  BroadcastchannelResponse,
  BroadcastCountDetails,
  BroadcastCountPayload,
  BroadcastTemplateResponse,
  TemplateTypes,
} from "types/Models/broadcast";

const extendedApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    createChatBroadcast: build.mutation<
      void,
      {
        broadcast_account: string;
        broadcast_name: string;
        email_template_id?: string;
        email_template_variables?: string;
        whatsapp_template_id?: string;
        whatsapp_template_variables?: string;
        scheduled_date: string;
        scheduled_time_start: string;
        scheduled_time_end: string;
      } & BroadcastCountPayload
    >({
      query: ({ ...props }) => {
        return {
          url: `/api/inkle/messaging/unified-broadcast/create/`,
          method: "post",
          body: makeFormData({
            ...props,
          }),
        };
      },
      invalidatesTags: ["ChatBroadcast", "BROADCAST_LIST"],
    }),
    parseBroadcastChannels: build.mutation<
      Pagination & {
        page_size: number;
        channels: BroadcastchannelResponse[];
        csv_content?: string;
      },
      {
        page_num: number;
        broadcast_csv?: File | null;
      }
    >({
      query: ({ broadcast_csv, ...queryParams }) => {
        const query = qs.stringify(queryParams, { addQueryPrefix: true });
        return {
          url: `/api/inkle/messaging/broadcast/file/upload/channel-list/${query}`,
          body: makeFormData({ broadcast_csv }),
          method: "POST",
        };
      },
    }),

    getBroadcastTemplate: build.query<
      BroadcastTemplateResponse,
      { templateType: TemplateTypes }
    >({
      query: ({ templateType }) =>
        `/api/inkle/messaging/channel/templates/broadcast/${templateType}/`,
      providesTags: ["BROADCAST_TEMPLATE"],
    }),

    getBroadcastChannelsCount: build.mutation<
      BroadcastCountDetails,
      BroadcastCountPayload
    >({
      query: (props) => {
        return {
          url: "/api/inkle/messaging/unified-broadcast/count/",
          method: "POST",
          body: makeFormData({
            ...props,
          }),
        };
      },
    }),
  }),
});

export const {
  useCreateChatBroadcastMutation,
  useParseBroadcastChannelsMutation,
  useGetBroadcastTemplateQuery,
  useGetBroadcastChannelsCountMutation,
} = extendedApi;
